import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@shared/shared.module';
import { ManagePasswordModalComponent } from './components/manage-password-modal/manage-password-modal.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarItemComponent } from './components/sidebar-item/sidebar-item.component';
import { SidebarLabelComponent } from './components/sidebar-label/sidebar-label.component';

@NgModule({
  declarations: [
    AvatarComponent,
    HeaderComponent,
    SidebarComponent,
    ManagePasswordModalComponent,
    SidebarItemComponent,
    SidebarLabelComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule.forChild(),
    SharedModule,
  ],
  exports: [
    AvatarComponent,
    HeaderComponent,
    SidebarComponent,
    ManagePasswordModalComponent,
  ]
})
export class ShellModule { }
